import { useEffect, useState } from "react";

import { getPrivateAvatarAccess } from "@/features/settings/accountSettingsPrivateClient";

export function usePrivateAvatarUrl(resourceId: string | null | undefined) {
  const [resolved, setResolved] = useState<{
    resourceId: string;
    url: string;
  } | null>(null);

  useEffect(() => {
    if (!resourceId) return;
    let isActive = true;
    void getPrivateAvatarAccess()
      .then((result) => {
        if (isActive && result.resourceId === resourceId) {
          setResolved({ resourceId, url: result.url });
        }
      })
      .catch(() => undefined);
    return () => {
      isActive = false;
    };
  }, [resourceId]);

  return resolved && resolved.resourceId === resourceId ? resolved.url : null;
}
